var MessagesMixin = {
  methods: {
    setMessages(severity, content, life) {
      let self = this;
      self.$store.commit('setMessages', [{ severity: severity, content: content, life: life, sticky: false }])
      setTimeout(function () { self.$store.commit('setMessages', []) }, life);
    },
    addWarnMessage(content) {
      let self = this;
      self.$store.commit('addMessage', { severity: 'warn', content: content, life: 3000, sticky: false })
      setTimeout(function () { self.$store.commit('setMessages', []) }, 3000);
    }
  }
};
export default MessagesMixin;